interface ISortedReaction {
  id: string;
  count: number;
}

export const sortReactions = (reaction1: ISortedReaction, reaction2: ISortedReaction): number => {
  if (reaction1.count === reaction2.count) {
    const bigInt1 = BigInt(reaction1.id);
    const bigInt2 = BigInt(reaction2.id);

    if (bigInt1 < bigInt2) {
      return -1;
    }

    if (bigInt1 > bigInt2) {
      return 1;
    }

    return 0;
  }

  return reaction2.count - reaction1.count;
};
